module.exports = __webpack_public_path__ + "f5b2855d7a11537edac6850973816182.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-28.png
// module id = 2014
// module chunks = 0